module.exports = __webpack_public_path__ + "static/img/deportes_10.fdff8d37.jpeg";